import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../Icon';

const CloseCircleIcon = ({ fill='#000', ...props }) => {
  return (
    <Icon viewBox="0 0 80 80" {...props}>
      <path
        fill={fill}
        d="M55.456,48.3725556 C57.0082222,49.9314444 57.0037778,52.4781111 55.4426667,54.0303333 L53.9604444,55.5058889 C52.4015556,57.0581111 49.856,57.0525556 48.3037778,55.4936667 L39.9837778,47.137 L31.6282222,55.4558889 C30.0671111,57.0081111 27.5215556,57.0025556 25.9693333,55.4425556 L24.4937778,53.9614444 C22.9404444,52.4014444 22.9471111,49.8547778 24.5071111,48.3036667 L32.8626667,39.9836667 L24.5448889,31.627 C22.9915556,30.0681111 22.9971111,27.5214444 24.556,25.9692222 L26.0382222,24.4936667 C27.5982222,22.9414444 30.1448889,22.947 31.6971111,24.507 L40.016,32.8636667 L48.3726667,24.5436667 C49.9315556,22.9914444 52.4782222,22.997 54.0304444,24.557 L55.506,26.0381111 C57.0582222,27.5981111 57.0526667,30.1447778 55.4926667,31.697 L47.1371111,40.0158889 L55.456,48.3725556 Z M40.0004444,0.000333333333 C17.9082222,0.000333333333 0.000444444444,17.9092222 0.000444444444,40.0003333 C0.000444444444,62.0914444 17.9082222,80.0003333 40.0004444,80.0003333 C62.0915556,80.0003333 80.0004444,62.0914444 80.0004444,40.0003333 C80.0004444,17.9092222 62.0915556,0.000333333333 40.0004444,0.000333333333 Z"
      />
    </Icon>
  );
};

CloseCircleIcon.propTypes = {
  fill: PropTypes.string,
};

export default CloseCircleIcon;
